import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './SortArrow.scss';

export default function SortArrow(props) {
  const {direction, className, ...restProps} = props;

  return (
    <div
      className={classnames(styles.container, className)}
      {...restProps}
    >
      <div className={classnames(styles.arrowUp, {[styles.visible]: direction >= 0})} />
      <div className={classnames(styles.arrowDown, {[styles.visible]: direction <= 0})} />
    </div>
  );
}

SortArrow.propTypes = {
  direction: PropTypes.number,
}

SortArrow.defaultProps = {
  direction: 0,
}


// WEBPACK FOOTER //
// ./src/components/controls/SortArrow.jsx